import { Button, ButtonGroup } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import { TextField } from 'formik-material-ui'
import React from 'react'
import styled from 'styled-components'

import { COLORS } from '../../../constants/colors'

const FormContainer = styled.div`
  position: relative;
  padding: 15px;
`

const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 5px 0;
`

const StyledTextField = styled(TextField)`
  && {
    margin: 12px 0;

    .Mui-focused {
      fieldset {
        border: 1px solid rgba(26, 25, 25, 0.4);
        box-shadow: 0 2px 6px 0 rgba(26, 25, 25, 0.2);
      }
    }

    &:hover {
      fieldset {
        border: 1px solid rgba(55, 111, 139, 0.6);
      }
    }

    .MuiSelect-select:focus {
      background: white;
    }

    .MuiOutlinedInput-root {
      height: 44px;
    }

    .MuiInputLabel-outlined.MuiInputLabel-shrink {
      font-size: 16px;
    }
  }
`

const NameLabel = styled.div`
  margin: 10px 10px 15px;
  color: rgba(26, 25, 25, 0.6);

  font-size: 22px;
  font-weight: 800;
  letter-spacing: -0.75px;
  line-height: 24px;
`

const ScheduleDateLabel = styled.div`
  font-size: 12px;
  margin-left: 14px;
  margin-bottom: 5px;
  line-height: 16px;
  font-family: 'Roboto'
  font-weight: 400;
  color: rgba(0, 0, 0, 0.6);
`

const ScheduleDateButtonGroup = withStyles({
  root: {
    borderColor: 'rgba(26, 25, 25, 0.2)',
    margin: '10px 0 5px',
  },
})((props) => <ButtonGroup fullWidth {...props} />)

const ScheduleDateButton = styled(Button)`
  && {
    color: ${(props) => (props.selected ? 'white' : 'rgba(26, 25, 25, 0.6)')};
    border-color: 'rgba(0, 0, 0, 0.23)';
    background-color: ${(props) => (props.selected ? COLORS.THEME.SECONDARY : 'white')};
    padding: 10px 0;

    &:hover {
      background-color: rgba(125, 160, 20, 1);
      color: white;
    }

    .MuiButton-label {
      font-size: 12px;
    }
  }
`

const AddButton = styled(Button)`
  && {
    background: #9DC31A;
    color: white;
    margin: 15px -15px -20px -15px;
    width: 360px;
    border-radius: 0 0 4px 4px;
    height: 44px;
    box-shadow: none;

    &:hover {
      background-color: rgba(125, 160, 20, 1);
      box-shadow: none;
    }
  }
`

export {
  FormContainer,
  InputContainer,
  StyledTextField,
  NameLabel,
  ScheduleDateLabel,
  ScheduleDateButtonGroup,
  ScheduleDateButton,
  AddButton,
}
